export enum StorageFtpProtocol {
  FTP = "FTP",
  SFTP = "SFTP",
  FTPS = "FTPS",
}
